<template>
  <div class="diagram-container content-container">
    <section class="diagram_sidebar">
      <div class="das-form-container das-form-group">
        <div class="das-form-input">
          <div class="label">
            {{ 'Ngày' }}
          </div>
          <CalendarSelect v-model="queryParams.date" mode="date" />
        </div>
      </div>
      <div class="diagram_sidebar_statuses"></div>
      <div class="diagram_sidebar_tags"></div>
      <div class="diagram_sidebar_buttons">
        <button class="btn primary small" @click="onFilter">Tìm kiếm</button>
      </div>
    </section>
    <section class="diagram_data">
      <RoomStatusCard v-for="room in rooms" :key="room"> </RoomStatusCard>
    </section>
    <RoomStatusDetailDialog
      v-if="isDetailDialogOpened"
    ></RoomStatusDetailDialog>
  </div>
</template>
<script>
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import RoomStatusCard from './roomMap/components/RoomStatusCard.vue'
import RoomStatusDetailDialog from './components/RoomStatusDetailDialog.vue'
export default {
  components: { CalendarSelect, RoomStatusCard, RoomStatusDetailDialog },
  data() {
    return {
      tags: [
        'OOO',
        'OOS',
        'Sai lệch',
        'Phòng trống',
        'Đến hạn đi',
        'Đến hôm nay',
        'Đang ở',
        'Sinh nhật',
        'Phòng trăng mật'
      ],
      statuses: ['Phòng bẩn', 'Phòng sạch', 'Đã kiểm tra', 'Không phục vụ'],
      roomStatusOptions: [],
      roomTagOptions: [],
      queryParams: {
        date: new Date(),
        status: [],
        tag: [],
        is_group: false,
        is_booked: false
      },
      rooms: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      isDetailDialogOpened: false
    }
  },
  async mounted() {
    await Promise.all([this.getRoomTagOptions(), this.getRoomStatusOptions()])
  },
  methods: {
    async getRoomTagOptions() {
      this.tags.forEach((tag, index) => {
        this.roomTagOptions.push({
          id: index,
          name: tag
        })
      })
    },
    async getRoomStatusOptions() {
      this.statuses.forEach((status, index) => {
        this.roomStatusOptions.push({
          id: index,
          name: status
        })
      })
    },
    async getRoomStatusData() {}
  }
}
</script>
<style scoped lang="scss">
.diagram-container {
  padding: 0;
  display: grid;
  grid-template-columns: auto 1fr;
}
.diagram_sidebar {
  padding: 16px;
  width: 240px;
  border-right: 1px solid var(--das-border-color);
  &_buttons {
    margin-top: 24px;
  }
}

.diagram_data {
  height: min-content;
  gap: 8px;
  padding: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fit, 180px);
}
</style>
